import { notificationHandlerSync } from 'utils/utils';
import { axiosAiq } from 'config';

export const DayNightModeChangeHandler = async function (camId, nightMode) {
    try {
        await axiosAiq.put(`/camera/${camId}/nightmode/${nightMode}`);
    } catch (err) {
        const { error } = err.response.data;
        notificationHandlerSync({ err, title: error });
    }
};
